<template>
  <v-app>
    <v-row class="px-4">
      <LoadingDialog v-if="loading" :is_loading="loading" />
      <v-col cols="12">
        <v-card v-if="!loading" elevation="0" style="margin-top: 15px">
          <v-card-title>
            <v-row>
              <v-col cols="4">
                {{ $t("_module_kpi_filter_") }}
              </v-col>
              <v-col cols="3" offset="5">
                <dates-selector
                  :store_date="$store.getters.niv2Dates"
                  :min_date="auditDates.start"
                  :max_date="auditDates.end"
                  :show_label="false"
                  :default_last_month="false"
                  store_cal_event="SET_NIV2_CALENDAR_REFRESH"
                  store_date_commit="SET_NIV2_DATES"
                />
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>

        <v-card v-if="!loading" elevation="0">
          <v-card-text class="main-template">
            <v-row class="mb-4">
              <v-col>
                <v-card
                  style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    margin-right: 60%;
                    height: 70px;
                  "
                >
                  <v-file-input
                    accept=".xlsx"
                    :label="
                      $t('_importer_des_donnees_pvsyst_(optionnel)_(xlsx)_')
                    "
                    v-model="file"
                    prepend-icon="mdi-file-excel"
                  />
                </v-card>
              </v-col>
            </v-row>

            <v-row class="mb-4">
              <v-col cols="5">
                <tree-select
                  style="height: 50px"
                  v-model="pdm"
                  :auto-load-root-options="false"
                  :defaultExpandLevel="expand_level"
                  :disable-branch-nodes="false"
                  :load-options="getAllPdmTree"
                  :multiple="true"
                  :options="ts_options"
                  :showCount="true"
                  :limit="1"
                  :value-consists-of="'ALL'"
                  :placeholder="$t('_point(s)_de_mesure_')"
                  v-on:input="select_pdm_value(pdm)"
                />
              </v-col>
              <v-col cols="5">
                <v-text-field
                  v-model="min_irradiance"
                  :label="$t('_rayonnement_solaire_minimum_')"
                  type="number"
                  dense
                />
              </v-col>
            </v-row>
            <v-row style="margin-top: -25px">
              <v-col cols="2">
                <v-btn @click="actualize_data">{{ $t("_actualiser_") }}</v-btn>
              </v-col>
            </v-row>
            <v-row style="margin-bottom: -40px; margin-top: 40px">
              <v-col class="d-flex align-center justify-space-between">
                <div
                  style="
                    white-space: nowrap;
                    margin-left: 25%;
                    font-weight: bold;
                    color: black;
                  "
                >
                  {{ $t("_resultats_pr_ip_avec_incidents_") }}
                </div>
                <div
                  style="
                    white-space: nowrap;
                    margin-right: 15%;
                    font-weight: bold;
                    color: black;
                  "
                >
                  {{ $t("_resultats_pr_ip_hors_incidents_") }}
                </div>
              </v-col>
            </v-row>

            <v-row justify="space-between" style="margin-top: 30px">
              <v-col cols="12">
                <v-data-table
                  :items="incidentData"
                  :headers="headers_values"
                  :footer-props="{
                    'items-per-page-options': [20, 50, 100, -1],
                    'items-per-page-text': this.$t('_lignes_par_page_'),
                  }"
                >
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item">
                        <td v-for="column in headers_values" :key="column">
                          <span v-if="[''].includes(column.value)">
                            <span>|</span>
                          </span>
                          <span v-if="['ts'].includes(column.value)">
                            <span>{{ item[column.value] }}</span>
                          </span>
                          <span
                            v-if="
                              [
                                'eac_ai',
                                'eac_fit_ai',
                                'irr_ai',
                                'eac_modele_ai',
                                'pr_heliocity_ai',
                                'ip_ai',
                              ].includes(column.value)
                            "
                          >
                            <span
                              v-if="
                                ['pr_heliocity_ai', 'ip_ai'].includes(
                                  column.value
                                )
                              "
                            >
                              {{ item[column.value] }}%
                            </span>
                            <span v-else>
                              {{ item[column.value] }}
                            </span>
                          </span>
                          <span
                            v-if="
                              [
                                'eac',
                                'eac_fit',
                                'irr',
                                'eac_modele',
                                'pr_heliocity',
                                'ip',
                              ].includes(column.value)
                            "
                            style="color: #228b22"
                          >
                            <span
                              v-if="
                                ['pr_heliocity', 'ip'].includes(column.value)
                              "
                            >
                              {{ item[column.value] }}%
                            </span>
                            <span v-else>
                              {{ item[column.value] }}
                            </span>
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="2">
                <v-btn @click="download_data">{{
                  $t("_telecharger_les_donnees_")
                }}</v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-app>
</template>

<script>
import DatesSelector from "@/components/Utils/DatesSelector";
import LoadingDialog from "@/components/Utils/LoadingDialog";
import TreeSelect from "@riophae/vue-treeselect";
import api from "@/api/api";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  components: {
    LoadingDialog,
    DatesSelector,
    TreeSelect,
  },
  mounted() {
    this.actualize_data();
  },

  data() {
    return {
      headers_values: [],
      headerData: [],
      table_data_qry: null,
      pdm: this.$store.getters.expert_pdm,
      installation_id: this.$route.params.id,
      ts_options: [],
      loading: false,
      min_irradiance: 50,
      file: null,
      incidentData: [],
      current_pdm_value: "",
      sendingValues: { input: [] },
    };
  },

  computed: {
    installation() {
      return this.$store.getters.installations.find(
        (x) => x.id == this.installation_id
      );
    },
    auditDates() {
      return this.$store.state.parametersStore.dates;
    },
    dates() {
      return this.$store.state.parametersStore.dates;
    },
  },

  watch: {
    $route: {
      async handler() {
        await this.getAllPdmTree();
        await this.refresh_header_values();
        await this.actualize_data();
      },
      immediate: true,
    },
    "$root.$i18n.locale": {
      async handler() {
        await this.getAllPdmTree();
        await this.refresh_header_values();
        await this.actualize_data();
      },
      immediate: true,
    },

    async "$store.getters.niv2CalendarRefresh"() {
      if (this.$store.getters.niv2CalendarRefresh) {
        this.$store.commit("SET_NIV2_CALENDAR_REFRESH", false);
      }
    },
  },

  methods: {
    async getAllPdmTree() {
      const langcode = this.$root.$i18n.locale;
      await api.getPdmTree(this.installation_id, langcode).then((res) => {
        this.ts_options = res.data["tree"];
        this.expand_level = res.data["expand_level"];
      });
    },
    select_pdm_value(pdm) {
      this.current_pdm_value = "";

      if (!pdm || pdm.length === 0) {
        return;
      }

      const result = [];

      for (const entry of pdm) {
        // Check if this entry contains an MPP part
        if (entry.includes("mpp")) {
          const parts = entry.split("|");
          const lastPart = parts[parts.length - 1]; // "mpp-6-10", etc.
          if (lastPart.startsWith("mpp")) {
            result.push(lastPart);
          }
        }
      }

      this.current_pdm_value = result.join(",");
    },

    select_irradiantion_value() {
      if (
        this.irradiantion_value === undefined ||
        this.irradiantion_value === null ||
        this.irradiantion_value.length === 0
      ) {
        this.irradiantion_value = 50;
      } else {
        this.irradiantion_value = this.irradiantion_value;
      }
    },
    refresh_header_values() {
      this.headers_values = [
        { text: this.$t("_time_"), value: "ts" },
        { text: this.$t("|"), value: "" },
        { text: this.$t("_eac_"), value: "eac_ai" },
        { text: this.$t("_eac_fit_"), value: "eac_fit_ai" },
        { text: this.$t("_irr_"), value: "irr_ai" },
        { text: this.$t("_eac_modele_"), value: "eac_modele_ai" },
        { text: this.$t("_pr_"), value: "pr_heliocity_ai" },
        { text: this.$t("_ip_"), value: "ip_ai" },
        { text: this.$t("|"), value: "" },
        { text: this.$t("_eac_"), value: "eac" },
        { text: this.$t("_eac_fit_"), value: "eac_fit" },
        { text: this.$t("_irr_"), value: "irr" },
        { text: this.$t("_eac_modele_"), value: "eac_modele" },
        { text: this.$t("_pr_"), value: "pr_heliocity" },
        { text: this.$t("_ip_"), value: "ip" },
      ];
    },

    async actualize_data() {
      this.loading = true;
      this.select_irradiantion_value();
      this.incidentData = [];
      const payload = {
        pdm: this.pdm,
        min_irradiance: this.min_irradiance,
        start_date: this.$store.getters.niv2Dates.start,
        end_date: this.$store.getters.niv2Dates.end,
      };
      try {
        this.sendingValues.input = [];
        if (this.file) {
          let result = await api.convertkpiXlsxToJson(this.file);
          this.sendingValues.input = Object.values(result.data);

          // Appel API
          const { data } = await api.getkpiData(
            this.sendingValues,
            this.installation_id,
            payload.start_date,
            payload.end_date,
            this.current_pdm_value,
            payload.min_irradiance
          );

          // Accéder aux données à l'intérieur de la clé `data`
          if (Array.isArray(data.data)) {
            this.table_data_qry = data;
            this.incidentData = this.table_data_qry.data.map((item) => {
              let dataItem = {};
              this.headers_values.forEach(({ value }) => {
                if (item[value] !== undefined) {
                  dataItem[value] = item[value];
                }
              });
              return dataItem;
            });
          } else {
            console.error(
              "Les données attendues ne sont pas sous forme de tableau:",
              data
            );
          }
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des données:", error);
      } finally {
        this.loading = false;
      }
    },

    // async download_data() {
    //   try {
    //     const payload = {
    //       data: { input: this.incidentData },
    //       header: this.headers_values,
    //       start_date: this.auditDates.start,
    //       end_date: this.auditDates.end,
    //     };
    //     console.log(this.current_pdm_value)
    //     const response = await api.convertJson(payload, "xlsx", this.$root.$i18n.locale, "data_table");
    //     const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    //     const url = URL.createObjectURL(blob);
    //     const link = document.createElement('a');
    //     link.href = url;
    //     link.download = `${this.$t("_module_expert_incident_")}${this.$route.params.id}.xlsx`;
    //     link.click();
    //     URL.revokeObjectURL(url);
    //   } catch (error) {
    //     console.error("Erreur lors du téléchargement des données:", error);
    //   }
    // },
    download_data() {
      this.headerData = [];

      for (let i = 0; i < this.headers_values.length; i++) {
        if (
          this.headers_values[i].text &&
          this.headers_values[i].value !== "" &&
          i > 1 &&
          i <= 7
        ) {
          this.headerData.push({
            text_: this.headers_values[i].text + "_ai",
            value: this.headers_values[i].value,
          });
        } else if (i < 1 || i > 8) {
          this.headerData.push({
            text_: this.headers_values[i].text,
            value: this.headers_values[i].value,
          });
        }
      }
      console.log(this.headerData);

      api
        .convertJsonIncident(
          { data: { input: this.table_data_qry }, header: this.headerData },
          "xlsx",
          this.$root.$i18n.locale,
          "data_table"
        )
        .then((res) => {
          let name =
            this.$t("_module_expert_kpi_filter_") +
            this.$route.params.id +
            ".xlsx";
          let a = document.createElement("a");
          a.href = URL.createObjectURL(res.data);
          a.download = name;
          a.click();
        });

      // console.log(this.headerData)
    },
  },
};
</script>

<style scoped>
.v-select-like {
  border: 1px solid black !important;
  width: 100vw;
  display: block;
  border-radius: 4px;
  outline: none;
  color: black;
}

.vue-treeselect {
  font-size: 0.9rem;
  font-weight: normal;
}

.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 16px 16px 16px 16px;
  border-bottom: #eee solid 1px;
}

html {
  overflow: hidden !important;
}

.v-card {
  padding: 16px 16px 16px 16px !important;
}
</style>
